import { render, staticRenderFns } from "./co-channel-pages.vue?vue&type=template&id=88937e82&"
import script from "./co-channel-pages.vue?vue&type=script&lang=ts&"
export * from "./co-channel-pages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports